export const RESERVATION_SERVICES_DIALOG_MESSAGES = {
	saveSuccess: 'Pomyślnie zapisano usługi',
	paymentTermFixedValueWarning:
		'W terminach płatności znajdowała się stała wartość!<br>Upewnij się, że suma wprowadzonych terminów jest zgodna z kwotą rezerwacji.',
} as const;
